// gatsby-browser.js
exports.onInitialClientRender = () => {
  const script = document.createElement('script');
  script.id = 'pixel-script-poptin';
  script.src = 'https://cdn.popt.in/pixel.js?id=238826761c522';
  script.async = true;
  document.body.appendChild(script);
};

// gatsby-browser.js
exports.onClientEntry = () => {
  document.cookie = "visitorId=abc123; Path=/; Secure; SameSite=Strict";
};

